import { Api, ConfigHelper, createApiService } from 'relapp-api';

export default {
    ...createApiService('dnssec', 'domain.dnssec'),

    /**
     * Enable DNSSEC
     *
     * @param {string} domainName
     *
     * @return {Promise}
     */
    enable(domainName) {
        const route = ConfigHelper.apiUrl('domain.dnssec.enable', [
            {
                key: '{domain}',
                value: domainName
            }
        ]);

        return Api.post(route);
    },

    /**
     * Enable DNSSEC with specified key
     *
     * @param {string} domainName
     * @param {array} dnssecKey
     * @returns {Promise}
     */
    enableWithKey(domainName, dnssecKey) {
        const route = ConfigHelper.apiUrl('domain.dnssec.enable', [
            {
                key: '{domain}',
                value: domainName
            }
        ]);

        return Api.post(route, dnssecKey);
    },

    /**
     * Disable DNSSEC
     *
     * @param {string} domainName
     *
     * @return {Promise}
     */
    disable(domainName) {
        const route = ConfigHelper.apiUrl('domain.dnssec.disable', [
            {
                key: '{domain}',
                value: domainName
            }
        ]);

        return Api.post(route);
    },

    /**
     * Check if manual DNSSEC is available.
     *
     * @param {string} domainName
     *
     * @return {Promise}
     */
    manualDnssecAvailable(domainName) {
        const route = ConfigHelper.apiUrl('domain.dnssec.manualdnssecavailable', [
            {
                key: '{domain}',
                value: domainName
            }
        ]);

        return Api.get(route);
    }
};
